import { createFileRoute } from '@tanstack/react-router';
import { StartPage } from '../../import/StartPage.js';

export interface StartSearch {
  /** "Import again": the finished run whose mapping the next draft carries. */
  from?: string | undefined;
}

export const Route = createFileRoute('/import/')({
  validateSearch: (search: Record<string, unknown>): StartSearch => ({
    from:
      typeof search.from === 'string' && /^[0-9a-f-]{36}$/.test(search.from)
        ? search.from
        : undefined,
  }),
  component: StartRoute,
});

function StartRoute(): React.JSX.Element {
  const { me } = Route.useRouteContext();
  const { from } = Route.useSearch();
  return <StartPage me={me} from={from} />;
}
